module.exports = __webpack_public_path__ + "img/headshot2.3775dce5.jpg";